/**
 * pwa.js
 * ---------------------------------------------------------------
 * Minimal, dependency-free PWA install/service-worker glue.
 * Sprint 1 goal is just the installability foundation ("Put Max in
 * your pocket") — not offline-first caching of dynamic app data.
 */

let deferredInstallPrompt = null;
const listeners = new Set();

export function initPwa() {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/service-worker.js").catch(() => {
        // Non-fatal: the app works perfectly well without an active
        // service worker, it just loses the offline app-shell cache.
      });
    });
  }

  window.addEventListener("beforeinstallprompt", (event) => {
    event.preventDefault();
    deferredInstallPrompt = event;
    listeners.forEach((cb) => cb(true));
  });

  window.addEventListener("appinstalled", () => {
    deferredInstallPrompt = null;
    listeners.forEach((cb) => cb(false));
  });
}

export function canPromptInstall() {
  return Boolean(deferredInstallPrompt);
}

export function onInstallAvailabilityChange(cb) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

export async function promptInstall() {
  if (!deferredInstallPrompt) return "unavailable";
  deferredInstallPrompt.prompt();
  const { outcome } = await deferredInstallPrompt.userChoice;
  deferredInstallPrompt = null;
  return outcome; // "accepted" | "dismissed"
}

export function isStandalone() {
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
}
